// RDV-002 : aides de date pour les rendez-vous. La Clinique rend « date_rdv_locale » (AAAA-MM-JJ HH:MM) dans le fuseau
// de l'établissement : on l'affiche tel quel, sans conversion par le navigateur. Les saisies partent en heure locale.

export const STATUTS_DEFAUT = {
    planifie: { libelle: 'Planifié', classe: 'badge-primary' },
    honore: { libelle: 'Honoré', classe: 'badge-success' },
    absent: { libelle: 'Absent', classe: 'badge-warning' },
    annule: { libelle: 'Annulé', classe: 'badge-danger' }
}

export const RAPPELS_DEFAUT = {
    a_faire: 'À appeler',
    confirme: 'Confirmé par téléphone',
    a_reprogrammer: 'À reprogrammer',
    injoignable: 'Injoignable'
}

export const RESULTATS_RAPPEL_DEFAUT = {
    confirme: 'Rendez-vous confirmé par le patient',
    a_reprogrammer: 'Le patient demande une autre date',
    injoignable: 'Patient injoignable',
    annule_patient: 'Rendez-vous annulé par le patient'
}

const deux = n => (n < 10 ? '0' : '') + n

// « 2026-09-25 09:30 » → « 25/09/2026 09:30 » ; « 2026-09-25 » → « 25/09/2026 »
export function date_lisible(locale) {
    if (!locale) return 'Non renseignée'
    const texte = String(locale).replace('T', ' ')
    const morceaux = texte.split(' ')
    const date = morceaux[0].split('-')
    if (date.length !== 3) return texte
    const heure = morceaux.length > 1 ? morceaux[1].substr(0, 5) : ''
    return date[2] + '/' + date[1] + '/' + date[0] + (heure ? ' ' + heure : '')
}

export function heure_lisible(locale) {
    if (!locale) return '—'
    const morceaux = String(locale).replace('T', ' ').split(' ')
    return morceaux.length > 1 ? morceaux[1].substr(0, 5) : '—'
}

export function jour_local(date) {
    const d = date instanceof Date ? date : new Date()
    return d.getFullYear() + '-' + deux(d.getMonth() + 1) + '-' + deux(d.getDate())
}

export function aujourdhui() {
    return jour_local(new Date())
}

export function ajouter_jours(date, nombre) {
    const morceaux = String(date).split('-')
    if (morceaux.length !== 3) return date
    const d = new Date(Number(morceaux[0]), Number(morceaux[1]) - 1, Number(morceaux[2]) + Number(nombre))
    return jour_local(d)
}

// Semaine du lundi au dimanche contenant la date
export function semaine(date) {
    const morceaux = String(date).split('-')
    const d = new Date(Number(morceaux[0]), Number(morceaux[1]) - 1, Number(morceaux[2]))
    const decalage = (d.getDay() + 6) % 7
    const lundi = jour_local(new Date(d.getFullYear(), d.getMonth(), d.getDate() - decalage))
    return { du: lundi, au: ajouter_jours(lundi, 6) }
}

const JOURS = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi']
const MOIS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre']

// « 2026-09-25 » → « vendredi 25 septembre 2026 »
export function jour_lisible(date) {
    const morceaux = String(date).split('-')
    if (morceaux.length !== 3) return String(date)
    const d = new Date(Number(morceaux[0]), Number(morceaux[1]) - 1, Number(morceaux[2]))
    if (Number.isNaN(d.getTime())) return String(date)
    return JOURS[d.getDay()] + ' ' + d.getDate() + ' ' + MOIS[d.getMonth()] + ' ' + d.getFullYear()
}

// C8 : périodes de l'agenda — jour, semaine du lundi au dimanche, mois civil — autour d'une date d'ancrage (AAAA-MM-JJ)
export const PERIODES = [{ id: 'jour', nom: 'Jour' }, { id: 'semaine', nom: 'Semaine' }, { id: 'mois', nom: 'Mois' }]

const en_date = (date) => {
    const morceaux = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(date || ''))
    return morceaux ? new Date(Number(morceaux[1]), Number(morceaux[2]) - 1, Number(morceaux[3])) : null
}

// Jour réel au format AAAA-MM-JJ (refuse 2026-02-30, 2026-13-01…)
export function jour_valide(date) {
    const d = en_date(date)
    return !!d && jour_local(d) === String(date)
}

// Mois civil contenant la date : du 1er au dernier jour
export function mois_civil(date) {
    const d = en_date(date)
    if (!d) return { du: date, au: date }
    return { du: jour_local(new Date(d.getFullYear(), d.getMonth(), 1)), au: jour_local(new Date(d.getFullYear(), d.getMonth() + 1, 0)) }
}

// Jours inclus de la période contenant la date
export function plage_periode(periode, date) {
    if (periode === 'semaine') return semaine(date)
    if (periode === 'mois') return mois_civil(date)
    return { du: date, au: date }
}

// Date d'ancrage de la période voisine : ± 1 jour, ± 7 jours, ou le 1er du mois voisin (fins de mois et d'année comprises)
export function deplacer_periode(periode, date, delta) {
    if (periode === 'semaine') return ajouter_jours(date, 7 * Number(delta))
    if (periode === 'mois') {
        const d = en_date(date)
        return d ? jour_local(new Date(d.getFullYear(), d.getMonth() + Number(delta), 1)) : date
    }
    return ajouter_jours(date, Number(delta))
}

export function capitaliser(texte) {
    const valeur = String(texte || '')
    return valeur.charAt(0).toUpperCase() + valeur.slice(1)
}

// « 2026-10-02 » → « Vendredi 2 octobre 2026 »
export function jour_titre(date) {
    return capitaliser(jour_lisible(date))
}

// « 2026-10 » ou « 2026-10-02 » → « Octobre 2026 »
export function mois_lisible(date) {
    const morceaux = /^(\d{4})-(\d{2})/.exec(String(date || ''))
    const mois = morceaux ? Number(morceaux[2]) : 0
    if (mois < 1 || mois > 12) return String(date || '')
    return capitaliser(MOIS[mois - 1]) + ' ' + morceaux[1]
}

// « Vendredi 2 octobre 2026 », « Semaine du 28/09 au 04/10/2026 » (année répétée si la semaine change d'année), « Octobre 2026 »
export function libelle_periode(periode, date) {
    if (periode === 'mois') return mois_lisible(date)
    if (periode === 'semaine') {
        const plage = semaine(date), du = date_lisible(plage.du)
        return 'Semaine du ' + (plage.du.substr(0, 4) === plage.au.substr(0, 4) ? du.substr(0, 5) : du) + ' au ' + date_lisible(plage.au)
    }
    return jour_titre(date)
}

// Instant ISO de la Clinique (création, appel…) → jour du poste « 20/09/2026 »
export function jour_instant(iso) {
    if (!iso) return ''
    const d = new Date(iso)
    return Number.isNaN(d.getTime()) ? '' : date_lisible(jour_local(d))
}

// Instant ISO de la Clinique → « 20/09/2026 à 10:12 » (heure du poste), vide si absent ou invalide
export function instant_lisible(iso) {
    if (!iso) return ''
    const d = new Date(iso)
    return Number.isNaN(d.getTime()) ? '' : date_lisible(jour_local(d)) + ' à ' + deux(d.getHours()) + ':' + deux(d.getMinutes())
}

const JOURS_COURTS = ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.']

// Colonne Date des tableaux compacts : « 2026-10-02 » → « ven. 02/10 » ; l'année n'est ajoutée que hors de l'année de
// référence (aujourd'hui de la Clinique, AAAA-MM-JJ) : « ven. 01/10/2027 »
export function jour_abrege(date, reference) {
    if (!jour_valide(date)) return '—'
    const d = en_date(date), morceaux = String(date).split('-')
    const annee = /^\d{4}/.test(String(reference || '')) ? String(reference).substr(0, 4) : String(new Date().getFullYear())
    return JOURS_COURTS[d.getDay()] + ' ' + morceaux[2] + '/' + morceaux[1] + (morceaux[0] !== annee ? '/' + morceaux[0] : '')
}

// « 2026-10-01 » → « jeudi 01/10/2026 »
export function jour_court(date) {
    const morceaux = String(date || '').split('-')
    if (morceaux.length !== 3) return String(date || '')
    const d = new Date(Number(morceaux[0]), Number(morceaux[1]) - 1, Number(morceaux[2]))
    if (Number.isNaN(d.getTime())) return String(date)
    return JOURS[d.getDay()] + ' ' + morceaux[2] + '/' + morceaux[1] + '/' + morceaux[0]
}

// RDV-006 : rendez-vous donné par le médecin sans heure. La Clinique le range à 00:00 du jour avec heure_a_fixer ;
// l'écran n'affiche jamais ce 00:00 mais « heure à fixer », jusqu'à ce que l'Accueil fixe l'heure.
export function est_heure_a_fixer(ligne) {
    if (!ligne) return false
    const valeur = ligne.heure_a_fixer
    return valeur === true || valeur === 1 || valeur === '1'
}

// Jour du rendez-vous (AAAA-MM-JJ, fuseau de l'établissement) : jour_local de la Clinique, sinon le début de date_rdv_locale
export function jour_rdv(ligne) {
    if (!ligne) return ''
    if (ligne.jour_local && /^\d{4}-\d{2}-\d{2}$/.test(String(ligne.jour_local))) return String(ligne.jour_local)
    return ligne.date_rdv_locale ? String(ligne.date_rdv_locale).replace('T', ' ').substr(0, 10) : ''
}

// L'heure reste à fixer seulement sur un rendez-vous planifié : honoré, absent ou annulé (reprogrammé), le drapeau peut
// rester à 1 côté Clinique, mais il n'y a plus rien à fixer — l'écran affiche alors « sans heure ».
export function heure_a_fixer_active(ligne) {
    return est_heure_a_fixer(ligne) && (ligne.statut || 'planifie') === 'planifie'
}

// « Fixer l'heure » possible : heure à fixer d'un rendez-vous dont le jour n'est pas passé. La Clinique refuse toute
// heure passée ; un jour passé se traite par Honoré, Absent ou Reprogrammer.
export function heure_a_fixer_possible(ligne) {
    if (!heure_a_fixer_active(ligne) || ligne.passe) return false
    const jour = jour_rdv(ligne)
    return !!jour && jour >= aujourdhui()
}

// Date et heure d'un rendez-vous : « 25/09/2026 09:30 », « jeudi 01/10/2026 · heure à fixer », ou, pour un rendez-vous
// clos resté sans heure, « jeudi 01/10/2026 · sans heure » (jamais 00:00)
export function date_rdv_lisible(ligne) {
    if (!ligne) return date_lisible(null)
    if (est_heure_a_fixer(ligne)) {
        const jour = jour_rdv(ligne), active = heure_a_fixer_active(ligne)
        if (!jour) return active ? 'Heure à fixer' : 'Sans heure'
        return jour_court(jour) + (active ? ' · heure à fixer' : ' · sans heure')
    }
    return date_lisible(ligne.date_rdv_locale)
}

// Heure seule (vue du jour) : « 09:30 », « Heure à fixer », ou « Sans heure » (rendez-vous clos)
export function heure_rdv(ligne) {
    if (est_heure_a_fixer(ligne)) return heure_a_fixer_active(ligne) ? 'Heure à fixer' : 'Sans heure'
    return heure_lisible(ligne ? ligne.date_rdv_locale : null)
}

// RDV-010 : « Générer le bon » depuis l'agenda — même état que le parcours normal (spécialité puis patient), sans ses
// étapes. Patient choisi : même forme que la liste des patients (choicePatient) ; téléphone brut du patient, jamais le
// téléphone affiché (qui peut être celui de l'accompagnant, suivi de sa filiation).
export function patient_bon_rendez_vous(ligne) {
    return {
        id: parseInt(ligne.patient_id), nom: ligne.patient_nom || '', nom_patient: ligne.patient_nom || '', prenoms: '', sexe: ligne.sexe || '',
        telephone_mobile: ligne.telephone === undefined ? null : ligne.telephone, age: ligne.age || '', num_dossier: ligne.dossier === undefined ? null : ligne.dossier
    }
}

// Spécialité choisie : { consult_id, consult_name, consult_abr } comme les actions rapides ; abréviation vide, comme les
// bons en attente (la liste des spécialités de la Clinique, /types_consultations, n'en renvoie pas)
export function type_bon_rendez_vous(ligne) {
    return { consult_id: Number(ligne.type_consultation_id), consult_name: String(ligne.type_consultation || ''), consult_abr: '' }
}

// Contexte du rendez-vous transmis au bon par la route (jamais gardé dans le magasin) : bandeau et médecin présélectionné
export function contexte_bon_rendez_vous(ligne) {
    const a_fixer = est_heure_a_fixer(ligne), heure = heure_lisible(ligne.date_rdv_locale)
    return {
        id: Number(ligne.rendez_vous_id), patient_id: Number(ligne.patient_id), type_consultation_id: Number(ligne.type_consultation_id),
        medecin_id: Number(ligne.medecin_id) > 0 ? Number(ligne.medecin_id) : null, medecin_nom: ligne.medecin_nom || '',
        heure: a_fixer || heure === '—' ? '' : heure, heure_a_fixer: a_fixer
    }
}

// Prochaine demi-heure ronde (heure locale du poste) : proposition par défaut du formulaire
export function prochaine_demi_heure(maintenant) {
    const d = maintenant instanceof Date ? new Date(maintenant.getTime()) : new Date()
    const minutes = d.getMinutes()
    d.setSeconds(0, 0)
    d.setMinutes(minutes < 30 ? 30 : 60)
    return { date: jour_local(d), heure: deux(d.getHours()) + ':' + deux(d.getMinutes()) }
}

export function libelle_statut(statut, referentiel) {
    const source = referentiel && referentiel.statuts && referentiel.statuts[statut] ? referentiel.statuts[statut] : STATUTS_DEFAUT[statut]
    return source && source.libelle ? source.libelle : (statut || '')
}

export function classe_statut(statut, referentiel) {
    const source = referentiel && referentiel.statuts && referentiel.statuts[statut] ? referentiel.statuts[statut] : STATUTS_DEFAUT[statut]
    return source && source.classe ? source.classe : 'badge-secondary'
}

// Tableaux compacts : pastille douce de l'état (tc-tone-*), comme le tableau du médecin
const TONS_STATUT = { planifie: 'primary', honore: 'success', absent: 'warning', annule: 'danger' }
export function ton_statut(statut) {
    return TONS_STATUT[statut] || 'muted'
}

export function message_erreur(error, repli) {
    return error && error.response && error.response.data && typeof error.response.data.message === 'string' ? error.response.data.message : repli
}
